<template>
    <div v-if="showFilters" class="bg-white dark:bg-gray-700 rounded-lg shadow p-4">
        <h2 class="mb-4 text-black dark:text-white">Filters</h2>
        <div class="grid grid-cols-3 gap-4">
            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Bonus Types</p>

                <select2
                    :options="bonusTypes"
                    key="bonus_types"
                    :multiple="true"
                    id="bonus_types"
                    select-label="name"
                    track-by-option="id"
                    name="bonus_types"
                    class="mt-1"
                    @sync="(value) => filterChanged('bonusTypes', value)"
                    :value="value.bonusTypes"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Game Types</p>
                <select2
                    :options="gameTypes"
                    key="game_types"
                    :multiple="true"
                    id="game_types"
                    select-label="name"
                    track-by-option="id"
                    name="game_types"
                    class="mt-1"
                    @sync="(value) => filterChanged('gameTypes', value)"
                    :value="value.gameTypes"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Payment Methods</p>
                <select2
                    :options="paymentMethods"
                    key="payment_methods"
                    :multiple="true"
                    id="payment_methods"
                    select-label="name"
                    track-by-option="id"
                    name="payment_methods"
                    class="mt-1"
                    @sync="(value) => filterChanged('paymentMethods', value)"
                    :value="value.paymentMethods"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Software</p>
                <select2
                    :options="software"
                    key="software"
                    :multiple="true"
                    id="software"
                    select-label="name"
                    track-by-option="id"
                    name="software"
                    class="mt-1"
                    @sync="(value) => filterChanged('software', value)"
                    :value="value.software"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Countries</p>
                <select2
                    :options="countries"
                    key="countries"
                    :multiple="true"
                    id="countries"
                    select-label="name"
                    track-by-option="id"
                    name="countries"
                    class="mt-1"
                    @sync="(value) => filterChanged('countries', value)"
                    :value="value.countries"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Currencies</p>
                <select2
                    :options="currencies"
                    key="currencies"
                    :multiple="true"
                    id="currencies"
                    select-label="name"
                    track-by-option="id"
                    name="currencies"
                    class="mt-1"
                    @sync="(value) => filterChanged('currencies', value)"
                    :value="value.currencies"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Licenses</p>
                <select2
                    :options="licenses"
                    key="licenses"
                    :multiple="true"
                    id="licenses"
                    select-label="name"
                    track-by-option="id"
                    name="licenses"
                    class="mt-1"
                    @sync="(value) => filterChanged('licenses', value)"
                    :value="value.licenses"
                />
            </div>
            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Launch Date</p>
                <Select
                    name="launch_date"
                    v-model="value.launchDate"
                    no-padding
                    placeholder="Select a launch date"
                    :options="[
                        {value: null, name: 'Select a launch date'},
                        {value: 6, name: 'last 6 months'},
                        {value: 12, name: 'last 12 months'},
                        {value: 18, name: 'last 1.5 years'},
                        {value: 24, name: 'last 2 years'},
                        {value: 30, name: 'last 2.5 years'},
                        {value: 36, name: 'last 3 years'},
                        {value: 42, name: 'last 3.5 years'},
                        {value: 48, name: 'last 4 years'},
                        {value: 54, name: 'last 4.5 years'},
                        {value: 60, name: 'last 5 years'},
                    ]"
                />
            </div>
            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Expert Rating (Min Score)</p>
                <Select
                    name="expert_rating"
                    v-model="value.expertRating"
                    no-padding
                    placeholder="Select an Expert Rating"
                    :options="[
                        {value: null, name: 'Select an Expert Rating'},
                        {value: 1, name: '1'},
                        {value: 2, name: '2'},
                        {value: 3, name: '3'},
                        {value: 4, name: '4'},
                        {value: 5, name: '5'},
                    ]"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Average RTP</p>
                <select2
                    :options="payoutRatios"
                    key="averageRtp"
                    id="averageRtp"
                    select-label="name"
                    track-by-option="id"
                    name="averageRtp"
                    class="mt-1"
                    @sync="(value) => filterChanged('payoutRatios', value)"
                    :value="value.payoutRatios"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Payout Within</p>
                <Select
                    name="payout_within"
                    v-model="value.payoutWithin"
                    no-padding
                    placeholder="Select a Payout Within"
                    :options="[
                        {value: null, name: 'Select a Payout Within'},
                        {value: 15, name: '15 mins'},
                        {value: 30, name: '30 mins'},
                        {value: 45, name: '45 mins'},
                        {value: 60, name: '1 hour'},
                        {value: 90, name: '1 hour 30 mins'},
                        {value: 120, name: '2 hours'},
                        {value: 180, name: '3 hours'},
                        {value: 300, name: '5 hours'},
                        {value: 1440, name: '24 hours'},
                        {value: 2880, name: '48 hours'},
                        {value: 4320, name: '72 hours'},
                    ]"
                />
            </div>

            <div
                class="w-full flex flex-col justify-end"
            >
                <Btn type="button" @click="$emit('filter')" content="Apply Filters"/>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "RankingFilter",
    props: {
        showFilters: {
            type: Boolean,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
        language: {
            type: Object,
            required: true,
        },
        bonusTypes: {
            type: Array,
            required: true,
        },
        gameTypes: {
            type: Array,
            required: true,
        },
        payoutRatios: {
            type: Array,
            required: true,
        },
        paymentMethods: {
            type: Array,
            required: true,
        },
        software: {
            type: Array,
            required: true,
        },
        countries: {
            type: Array,
            required: true,
        },
        currencies: {
            type: Array,
            required: true,
        },
        licenses: {
            type: Array,
            required: true,
        }
    },
    methods: {
        bonusTypesChanged(value) {
            this.value.bonusTypes = value || null;
        },
        gameTypesChanged(value) {
            this.value.gameTypes = value || null;
        },
        paymentMethodsChanged(value) {
            this.value.paymentMethods = value || null;
        },
        filterChanged(name, value) {
            this.value[name] = value || null
        },
    },
}
</script>
